import {
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IProduct } from "src/app/commons/product-card/IProduct";
import {
  GeneralService,
  ProductService,
  VendorService,
} from "src/app/commons/services";
import { ApiService, CacheService } from "src/app/core/services";

import { SiteConfigService } from "src/app/core/services/site-config.service";
import { IVendor } from "../vendor/ITypes";

@Component({
  selector: "sv-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  isHomePageDynamic?: boolean = false;
  loading: boolean = false;
  pageContent: any = null;
  pageContentBody: any = null;
  relatedProducts: any = [];
  dynamicSections: any = [];
  loadingProducts: boolean = true;
  vendorProducts: IProduct[] = [];
  loadingVendorProducts: boolean = true;
  limit: string = "14";
  page: string = "1";
  vendor: IVendor = null;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private siteConfigService: SiteConfigService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    public generalService: GeneralService,
    private productService: ProductService,
    private vendorService: VendorService
  ) {
    let { homePage } = this.siteConfigService.siteConfig;

    this.isHomePageDynamic = homePage.isDynamic;

    if (this.isHomePageDynamic === true) {
      this.getDynamicHomePage(homePage.contentURL);
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.generalService.setWidthVariableInStyle();
  }

  ngOnInit() {
    this.generalService.setWidthVariableInStyle();

    // Subscribe to vendor change
    this.vendorService.vendorObs$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((vendor) => {
        this.vendor = vendor;
        this.getVendorProducts();
      });
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions when the component is destroyed
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async getDynamicHomePage(contentURL) {
    this.pageContent = null;
    this.loading = true;

    try {
      const { status_code, result } = await this.apiService
        .get(contentURL)
        .toPromise();

      if (status_code === 200 && result && result.length) {
        this.loading = false;
        this.dynamicSections = result;

        await Promise.all(
          this.dynamicSections.map(async (element) => {
            element.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(
              element.content
            );
            element.fetched_related_products = [];

            if (element.related_products && element.related_products.length) {
              element.fetched_related_products = await this.getRelatedProducts(
                element.related_products
              );
            }
          })
        );

        this.loadingProducts = false;
      }
    } catch (error) {
      this.loading = false;
      throw error;
    }
  }

  async getRelatedProducts(searchPhrase) {
    return await this.productService.getProducts(
      {
        search: searchPhrase,
      },
      false,
      "/related"
    );
  }

  private async getVendorProducts() {
    const products = await this.productService.getProducts(
      {
        limit: this.limit,
        page: this.page,
        only_vendor_products: "true",
      },
      true
    );
    this.vendorProducts = products;
    this.loadingVendorProducts = false;
  }
}
